var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Not Found")]),_c('h5',[_vm._v("The requested page could not be found.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }